// modified InfoContainer from swagger-ui
// ref: https://github.com/swagger-api/swagger-ui/blob/4d9ec4fb0eaaddb7e1a8f4502e8e8577d40e46ec/src/core/containers/info.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { SwaggerComponentProps } from '../types/SwaggerComponentProps';
import DInfo from './DInfo';

export default class DInfoContainer extends React.Component<SwaggerComponentProps> {
  static propTypes = {
    specActions: PropTypes.object.isRequired,
    specSelectors: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired,
    oas3Selectors: PropTypes.func.isRequired,
  };

  render() {
    const { specSelectors, getComponent } = this.props;

    const info = specSelectors.info();
    const url = specSelectors.url();
    const basePath = specSelectors.basePath();
    const host = specSelectors.host();
    const schemes = specSelectors.schemes();
    const isSwagger2 = specSelectors.isSwagger2();
    const servers = specSelectors.servers();

    const externalDocs = specSelectors.externalDocs();

    let hostUrl = host;
    if (isSwagger2) {
      hostUrl = `${schemes.first()}://${host}`;
    } else if (servers && servers.size) {
      hostUrl = servers.first().get('url');
    }

    return (
      <div>
        {info && info.count() ? (
          <DInfo
            info={info}
            url={url}
            host={hostUrl}
            basePath={basePath}
            externalDocs={externalDocs}
            getComponent={getComponent}
          />
        ) : null}
      </div>
    );
  }
}
